import { render } from "./CreateSecteur.vue?vue&type=template&id=9b6ad706"
import script from "./CreateSecteur.vue?vue&type=script&lang=js"
export * from "./CreateSecteur.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__